module.exports = __webpack_public_path__ + "img/swiper1.85d3ce66.jpg";